<template>
    <div class="advanced-search">

        <div v-if="!onlyModal" class="swiper advanceSearchSwiper">
            <div class="swiper-wrapper d-flex">
                <a :href="vehicleRoute + '/all/RV-SUV'" class="item swiper-slide">
                    <img src="/img/site/icons/vehicles/suv.svg" alt="suv" width="" height="">
                    <span>RVs/SUVs</span>
                </a>
                <a :href="vehicleRoute + '/all/Hatchback'" class="item swiper-slide">
                    <img src="/img/site/icons/vehicles/hatchbacks.svg" alt="Hatchbacks" width="56" height="23">
                    <span>Hatchbacks</span>
                </a>
                <a :href="vehicleRoute + '/all/Sedan'" class="item swiper-slide">
                    <img src="/img/site/icons/vehicles/sedan.svg" alt="sedans" width="60" height="22">
                    <span>Sedans</span>
                </a>
                <a :href="vehicleRoute + '/all/Ute'" class="item swiper-slide">
                    <img src="/img/site/icons/vehicles/utes.svg" alt="Utes" width="60" height="23">
                    <span>UTEs</span>
                </a>
                <a :href="vehicleRoute + '/all/7_Seaters'" class="item swiper-slide">
                    <img src="/img/site/icons/vehicles/7seater.svg" alt="7 Seaters" width="50" height="22">
                    <span>7 Seaters</span>
                </a>
                <a :href="vehicleRoute + '/all/Hybrid-EV'" class="item swiper-slide">
                    <img src="/img/site/icons/vehicles/EVs.svg" alt="Hybrid & EV" width="57" height="38">
                    <span>Hybrid &amp; EV</span>
                </a>
                <a :href="vehicleRoute + '/all/On_Sale'" class="item swiper-slide">
                    <img src="/img/site/icons/vehicles/on-sale.svg" alt="On Sale" class="sml-icon" width="28"
                        height="24">
                    <span>On Sale Now</span>
                </a>
            </div>
            <div class="swiper-pagination mt-3"></div>
        </div>

        <button v-if="!onlyModal" v-on:click="searchModal = true" type="button" class="btn-ad-search" width="60" height="30">
            Advanced search
            <img src="/img/site/icons/plus-red.svg" alt="Advanced Search" width="12" height="12">
        </button>

        <b-modal :visible="searchModal" v-on:cancel="hideModal" v-on:hide="hideModal" body-class="p-0-"
            modal-class="modalSlide" hide-footer title="Vehicle Search">
            <template #modal-header="{ close }">
                <button v-on:click="close()" type="button" class="close" aria-label="Close">
                    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Vehicle-List-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Vehicle-List-5" transform="translate(-954.000000, -184.000000)" fill="#333333">
                                <g id="Close" transform="translate(954.000000, 184.000000)">
                                    <polygon points="20 2 18 0 10 8 2 0 0 2 8 10 0 18 2 20 10 12 18 20 20 18 12 10">
                                    </polygon>
                                </g>
                            </g>
                        </g>
                    </svg>
                </button>
                <div class="modal-title h5 mx-auto" id="myModalLabel">Vehicle Search</div>
            </template>

            <form :action="vehicleSearch" method="get" id="form-advancedsearch">

                <div class="form-group">
                    <label for="filter-keywords">Search:</label>
                    <input v-model="localSearch.keywords"
                        id="filter-keywords"
                        type="text"
                        class="form-control" />
                </div>

                <div class="form-group">
                    <label for="filter-branchid">Dealership:</label>
                    <select v-model="localSearch.branchid" title="Any" name="branchid[]" id="filter-branchid"
                        class="form-select form-select--gradient filter-select" multiple>
                        <option v-for="branch in filtered.branches" :key="branch.id" :value="branch.id">
                            {{ branch.name }}
                            {{ !_.isNull(branch.count) ? ` (${branch.count})` : '' }}
                        </option>
                    </select>
                    <!-- <v-select :options="filtered.branches"
                        v-model="localSearch.branchid"
                        label="name"
                        :reduce="branch => branch.id"
                        :clearable="false">
                        <template v-slot:option="option">
                            {{ option.name }}
                            <span v-if="!_.isNull(option.count)">({{ option.count }})</span>
                        </template>
                    </v-select> -->

                </div>

                <div class="form-group">
                    <label for="filter-type">Body style:</label>
                    <select v-model="localSearch.type" title="All" name="type" id="filter-type"
                        class="form-select form-select--gradient filter-select">
                        <option v-for="(type) in filtered.types" :key="`vtype${type.id}`" :value="type.id">
                            {{ type.name }}
                            {{ !_.isNull(type.count) ? ` (${type.count})` : '' }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="filter-fueltype">Fuel Type:</label>
                    <select v-model="localSearch.fueltype" name="fueltype[]" id="filter-fueltype"
                        title="All" class="form-select form-select--gradient filter-select" multiple>
                        <!-- <option value="">All</option> -->
                        <option v-for="fueltype in localFilters.fueltypes" :key="fueltype.id"
                            :value="fueltype.id">
                            {{ fueltype.name }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="filter-manufacturer">Make:</label>
                    <select v-model="localSearch.manufacturer" title="All Makes" name="manufacturer"
                        id="filter-manufacturer" class="form-select form-select--gradient filter-select">
                        <option v-for="manufacturer in filtered.manufacturers" :key="manufacturer.id"
                            :value="manufacturer.id" :data-subtext="'(' + manufacturer.numvehicles + ')'">
                            {{ manufacturer.name }}
                            {{ !_.isNull(manufacturer.count) ? ` (${manufacturer.count})` : '' }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="filter-model">Model:</label>
                    <select v-model="localSearch.model" title="All" name="model" id="filter-model"
                        class="form-select form-select--gradient filter-select">
                        <option v-for="model in filtered.models" :key="model.id" :value="model.id"
                            :data-subtext="'(' + model.numvehicles + ')'">
                            {{ model.name }}
                            {{ !_.isNull(model.count) ? ` (${model.count})` : '' }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <div class="btn-group btn-group-justified w-100" role="group" aria-label="Filter by range">
                        <button type="button" v-on:click="updateFilterRange('price')"
                            :class="[localSearch.filterrange == 'price' ? 'active' : '', 'btn py-auto btn-gradient btn-filterrange-v']">Price</button>
                        <button type="button" v-on:click="updateFilterRange('km')"
                            :class="[localSearch.filterrange == 'km' ? 'active' : '', 'btn py-auto btn-gradient btn-filterrange-v']">Kilometers</button>
                    </div>
                    <input type="hidden" name="filterrange" v-model="localSearch.filterrange">
                </div>

                <div id="filterrange-container">

                    <div id="filterrange-price" v-show="localSearch.filterrange == 'price'" :class="['form-group']">
                        <fieldset class="two-btns justify">
                            <label v-on:click="updateRangeType('price')" for="pr-price" class="label-lg radio--custom">
                                <input type="radio" class="btn-rangetype-v" name="rangetype" id="pr-price"
                                    value="price"
                                    v-model="localSearch.rangetype"
                                    :checked="_.isNull(_.get(localSearch, 'rangetype', null)) || _.get(localSearch, 'rangetype', null) == 'price'">
                                Vehicle Price Range
                                <span class="checkmark"></span>
                            </label>

                            <label v-on:click="updateRangeType('weeklypayment')" for="pr-weeklypayment" class="label-lg radio--custom">
                                <input type="radio" class="btn-rangetype-v" name="rangetype" id="pr-weeklypayment"
                                    value="weeklypayment"
                                    v-model="localSearch.rangetype"
                                    :checked="_.get(localSearch, 'rangetype', null) == 'weeklypayment'">
                                Weekly Price Range
                                <span class="checkmark"></span>
                            </label>
                        </fieldset>
                    </div>

                    <div v-show="!_.isNull(localSearch.filterrange)" id="range-sliders">
                        <div id="price-range-both-wrap" class="['form-group mb-0']">
                            <div id="price-range-slider-wrap"
                                v-show="localSearch.filterrange == 'price' && localSearch.rangetype == 'price'"
                                :class="[]">
                                <div class="form-group mb-1">
                                    <div class="range-slider">
                                        <div id="price-range-slider"></div>
                                        <input type="hidden" id="pricemin" name="pricemin"
                                            :value="_.get(localSearch, 'pricemin', 1000)">
                                        <input type="hidden" id="pricemax" name="pricemax"
                                            :value="_.get(localSearch, 'pricemax', 50000)">
                                    </div>
                                </div>

                                <div id="amount" class="row slider-amount-display font-weight-normal">
                                    <div class="col">
                                        <span>$</span><span id="pricemin-display">{{ number_format(_.get(localSearch,
                    'pricemin', 1000), 0) }}</span>
                                    </div>
                                    <div class="col text-end">
                                        <span>$</span><span id="pricemax-display">{{ _.get(localSearch, 'pricemax',
                    50000) == 50000 ? '50k+' : number_format(localSearch.pricemax, 0) }}</span>
                                    </div>
                                </div>
                            </div>

                            <div id="payment-range-slider-wrap"
                                v-show="localSearch.filterrange == 'price' && localSearch.rangetype == 'weeklypayment'"
                                :class="[]">
                                <div class="form-group mb-1">
                                    <div class="range-slider">
                                        <div id="payment-range-slider"></div>
                                        <input type="hidden" id="paymentmin" name="paymentmin"
                                            :value="_.get(localSearch, 'paymentmin', 30)">
                                        <input type="hidden" id="paymentmax" name="paymentmax"
                                            :value="_.get(localSearch, 'paymentmax', 200)">
                                    </div>
                                </div>
                                <div id="payment-amount" class="row slider-amount-display font-weight-normal">
                                    <div class="col">
                                        <span>$</span><span id="paymentmin-display">{{ number_format(_.get(localSearch,
                    'paymentmin', 30), 0) }}</span> / pw
                                    </div>
                                    <div class="col text-end">
                                        <span>$</span><span id="paymentmax-display">{{ _.get(localSearch, 'paymentmax',
                    200) == 200 ? '200+' : number_format(_.get(localSearch, 'paymentmax', 200),
                        0) }}</span> / pw
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="km-range-slider-wrap" v-show="localSearch.filterrange == 'km'">
                            <div class="form-group mb-1">
                                <div class="range-slider">
                                    <div id="km-range-slider"></div>
                                    <input type="hidden" id="kmmin" name="kmmin"
                                        :value="_.get(localSearch, 'kmmin', 10000)">
                                    <input type="hidden" id="kmmax" name="kmmax"
                                        :value="_.get(localSearch, 'kmmax', 250000)">
                                </div>
                            </div>
                            <div id="amount" class="row slider-amount-display">
                                <div class="col">
                                    <span id="kmmin-display">{{ number_format(_.get(localSearch, 'kmmin', 10000), 0)
                                        }}</span><span>kms</span>
                                </div>
                                <div class="col text-end">
                                    <span id="kmmax-display">{{ _.get(localSearch, 'kmmax', 250000) == 250000 ?
                    '250,000+' : number_format(_.get(localSearch, 'kmmax', 250000), 0)
                                        }}</span><span>kms</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="advanced-seach-fields" v-show="showAdvanced">

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="filter-externalcolour">Colour:</label>
                                <select v-model="localSearch.externalcolour" title="All" name="externalcolour"
                                    id="filter-externalcolour" class="form-select form-select--gradient filter-select">
                                    <option :value="null">All</option>
                                    <option v-for="(colour,idx) in localFilters.colours" :key="`colour${idx}`" :value="colour.id">
                                        {{ colour.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label for="filter-seats">Seats:</label>
                                <select v-model="localSearch.seats" title="All" name="seats" id="filter-seats"
                                    class="form-select form-select--gradient">
                                    <option value="">All</option>
                                    <option v-for="ind in 9" :key="ind" :value="ind">
                                        {{ ind >= 9 ? ind + '+' : ind }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row">

                        <div class="col">
                            <div class="form-group">
                                <label for="filter-fuelstars">Fuel Stars:</label>
                                <select v-model="localSearch.fuelstars" title="All" name="fuelstars"
                                    id="filter-fuelstars" class="form-select form-select--gradient filter-select">
                                    <option value="">All</option>
                                    <option v-for="fuelstar in localFilters.fuelstars" :key="fuelstar.id"
                                        :value="fuelstar.id">
                                        {{ fuelstar.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div> -->

                    <div class="form-group">
                        <label for="filter-transmission">Transmission:</label>
                        <select v-model="localSearch.transmission" title="All" name="transmission"
                            id="filter-transmission" class="form-select form-select--gradient">
                            <option value="">All</option>
                            <option v-for="transmission in localFilters.transmission" :key="transmission.id"
                                :value="transmission.id">
                                {{ transmission.name }}
                            </option>
                        </select>
                    </div>

                    <!-- <div class="form-group">
                        <label for="filter-transmission">Clean Car:</label>
                        <select v-model="localSearch.cleancar" title="Any Fee/Rebate" name="cleancar"
                            id="filter-clean-car" class="form-select form-select--gradient">
                            <option value="">Any Fee/Rebate</option>
                            <option value="fee">Fee</option>
                            <option value="rebate">Rebate</option>
                        </select>
                    </div> -->

                    <div class="row">
                        <div class="col">
                            <div class="checkbox checkbox--custom">
                                <label for="newarrivals" class="check-container">
                                    <input v-model="localSearch.newarrivals" type="checkbox" name="newarrivals"
                                        id="newarrivals" value="1"> New Arrivals
                                    <span class="checkmark" style="right:auto;"></span>
                                </label>
                            </div>
                        </div>
                        <div class="col">
                            <div class="checkbox checkbox--custom">
                                <label for="sale" class="check-container">
                                    <input v-model="localSearch.sale" type="checkbox" name="sale" id="sale" value="1">
                                    On Sale
                                    <span class="checkmark" style="right:auto;"></span>
                                </label>
                            </div>
                        </div>
                        <div class="col">
                            <div class="checkbox checkbox--custom">
                                <label for="budget_range" class="check-container">
                                    <input v-model="localSearch.budget_range" type="checkbox" name="budget_range" id="budget_range" value="1">
                                    Budget Range
                                    <span class="checkmark" style="right:auto;"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-10 mx-auto">
                        <div class="form-group buttons d-flex flex-column">
                            <input type="hidden" name="listingsearch" value="1">
                            <input type="hidden" name="advancedsearch" :value="showAdvanced">
                            <button type="submit" @click.stop.prevent="getFormValues"
                                class="btn btn-lg btn-rnd btn-primary btn-block btn-search mb-3">Search</button>
                            <button type="button" v-on:click="showAdvanced = showAdvanced == 1 ? 0 : 1"
                                class="btn btn-lg btn-rnd btn-default btn-block">
                                {{ !showAdvanced ? 'More Options' : 'Less Options' }}
                            </button>
                            <button type="button" v-on:click="resetForm()"
                                class="btn btn-lg btn-rnd btn-white btn-block">
                                <img src="/img/site/icons/reset.svg" alt="Reset icon">
                                Reset search
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import UtilsMixin from '../UtilsMixin';
import RangeSlider from 'vue-range-slider';
import axios from 'axios';
import Swiper from 'swiper/bundle';;

export default {

    data() {
        return {
            onlyModal: false,
            searchModal: false,
            localFilters: {},
            localSearch: {},
            showAdvanced: 0,
            filterRequestString: null,
            defaultRequest: {
                logsearch: 1,
                branchid: [],
                type: null,
                manufacturer: null,
                model: null,
                externalcolour: null,
                seats: '',
                fuelstars: '',
                transmission: '',
                cleancar: '',
            }
        }
    },

    props: ['showModal', 'qRequest', 'searchFilters', 'vehicleRoute', 'vehicleSearch', 'advancedSearch', 'modalOnly'],

    mixins: [UtilsMixin],

    components: {
        RangeSlider,
    },

    created() {

    },

    mounted() {

        this.localFilters = this.searchFilters;
        this.showAdvanced = this.advancedSearch;
        this.searchModal = _.get(this, 'showModal', false);

        this.onlyModal = _.get(this, 'modalOnly', false);

        if (!this.onlyModal) {
            var swiper = new Swiper(".advanceSearchSwiper", {
                // loop:true,
                slidesPerView: 2,
                breakpoints: {
                    768: {
                        slidesPerView: 6,
                    },
                    1200: {
                        slidesPerView: 7,
                    }
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }
    },

    watch: {

        // 'localSearch.type': function () {
        //     this.axiosFilterUpdate('getColours', 'colours');
        // },
        // 'localSearch.manufacturer': function () {
        //     this.axiosFilterUpdate('getModels', 'models');
        // },
        // 'localSearch.model': function () {
        //     this.axiosFilterUpdate('getVehicleTypes', 'types');
        // },
        // 'localSearch.externalcolour': function () {
        //     this.axiosFilterUpdate('getFuelTypes', 'fueltypes');
        // },
        // 'localSearch.fueltype': function () {
        //     this.axiosFilterUpdate('getFuelStars', 'fuelstars');
        // },
        // 'localSearch.fuelstars': function () {
        //     this.axiosFilterUpdate('getTransmission', 'transmission');
        // },

        searchModal(newVal) {
            if (newVal == true) {
                this.$emit('toggleModal', true);
                this.$nextTick(() => {
                    this.initSelects();
                    window.PriceSliderMin = $('#pricemin').val().replace(/,/g, '');
                    window.PriceSliderMax = $('#pricemax').val().replace(/,/g, '');
                    window.PaymentSliderMin = $('#paymentmin').val();
                    window.PaymentSliderMax = $('#paymentmax').val();
                    window.KmSliderMin = $('#kmmin').val();
                    window.KmSliderMax = $('#kmmax').val();

                    refineSearchFilters();
                });
            }
        },

        showModal(newVal) {
            this.searchModal = newVal;
            if (newVal == true) {
                this.$nextTick(() => {
                    MultiselectDropdown(window.MultiselectDropdownOptions);
                    showBsModals();
                });
            } else {
                this.$nextTick(() => {
                    hideBsModals();
                });
            }
        },

        qRequest: {
            handler(newVal) {
                this.localSearch = {
                    ...this.defaultRequest,
                    ...this.qRequest
                }
                if (_.isUndefined(this.localSearch.branchid) || _.isNull(this.localSearch.branchid)) {
                    this.localSearch.branchid = [];
                }
                if (!_.isArray(this.localSearch.branchid)) {
                    this.localSearch.branchid = _.split(this.localSearch.branchid, ',');
                }
                if (_.isUndefined(this.localSearch.fueltype) || _.isNull(this.localSearch.fueltype)) {
                    this.localSearch.fueltype = [];
                }
                if (!_.isArray(this.localSearch.fueltype)) {
                    this.localSearch.fueltype = _.split(this.localSearch.fueltype, ',');
                }
            },
            deep: true,
            immediate: true,
        },

        selectConfig() {
            let config = {
                allowClear: false,
            }
            return config;
        },

        placeholder() {
            return 'Click me!';
        },
    },

    computed: {

        filtered() {

            let branches = this.filterLocalFilter('branches', null);
            let types = this.filterLocalFilter('types', 'All');
            let manufacturers = this.filterLocalFilter('manufacturers', 'All Makes');
            let models = this.filterLocalFilter('models', 'All', 'manufacturer');

            return {
                branches,
                types,
                manufacturers,
                models,
            }
        }
    },

    methods: {

        filterLocalFilter(type, placeholder = 'Please select', dependant = false) {
            let fObject = _.get(this.localFilters, type, []);
            let fArray = Object.entries(fObject).map(([fk, fv]) => {
                return fv;
            });

            let fOutput = fArray.map((lf) => {
                let mapped = {
                    id: lf.id,
                    name: lf.name,
                    count: _.get(lf, 'numvehicles', null),
                };
                if (dependant) {
                    mapped[dependant] = _.get(lf, dependant, null);
                }
                return mapped;
            }).filter((lf) => {
                if (dependant == false) {
                    return true;
                }
                if (_.isNull(_.get(this.localSearch, dependant, null))) {
                    return true;
                }
                return lf[dependant] == _.get(this.localSearch, dependant, null);
            });
            if (!_.isNull(placeholder)) {
                fOutput.unshift({
                    id: null,
                    name: placeholder,
                    count: null,
                });
            }
            return fOutput;
        },

        // axiosFilterUpdate(endpoint, filterKey) {
        //     let params = new URLSearchParams(this.localSearch);
        //     axios.get('/api/vehicles/data/' + endpoint + '/true?' + params.toString(), {
        //     }).then((res) => {
        //         this.localFilters[filterKey] = res.data.data;
        //         this.$nextTick(() => {
        //             this.refreshSelects();
        //         });
        //     });
        // },

        resetForm() {
            this.localSearch = {
                fueltype: [],
                page: this.localSearch.page,
                lazyload: this.localSearch.lazyload,
                orderby: this.localSearch.orderby,
            };
            this.hideModal();
            this.$emit('resetSearch', this.localSearch);
        },

        getFormValues(e) {
            this.localSearch = {
                ...this.localSearch,
                pricemin: $('#pricemin').val().replace(/,/g, ''),
                pricemax: $('#pricemax').val().replace(/,/g, ''),
                paymentmin: $('#paymentmin').val(),
                paymentmax: $('#paymentmax').val(),
                kmmin: $('#kmmin').val().replace(/,/g, ''),
                kmmax: $('#kmmax').val().replace(/,/g, ''),
                advancedsearch: this.showAdvanced,
                listingsearch: true,
            }
            delete this.localSearch['fueltype[]'];

            if (!this.modalOnly) {
                this.hideModal();
            }
            this.$emit('runSearch', this.localSearch);
        },

        updateFilterRange(value) {
            this.$set(this.localSearch, 'filterrange', value);
        },

        updateRangeType(value) {
            this.$set(this.localSearch, 'rangetype', value);
        },

        hideModal() {
            this.searchModal = false;
            this.$emit('toggleModal', false);
        },

        number_format(value, decimal) {
            return parseFloat(value).toFixed(decimal);
        },

        initSelects(destroy = false, ignoreWatchers = false) {
            let pickers = $('.select2');
            if (pickers.length) {
                pickers.each((id, el) => {
                    // if (destroy) {
                    //     $(el).select2("destroy");
                    // }
                    // $(el).select2({
                    //     placeholder: this.placeholder,
                    //     ...this.selectConfig,
                    // });
                    // if (!ignoreWatchers) {
                    //     this.addSelect2Watchers(el);
                    // }
                });
            }
        },

        refreshSelects() {
            return;
            // this.$nextTick(() => {
            //     let pickers = $('.selectpicker');
            //     pickers.each((id, el) => {
            //         $(el).selectpicker('refresh');
            //     });
            // });
        },
    }
}
</script>